
/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */

// 测试
// export const PAGE_NAME = "仅供测试";  //all title
// export const PAGE_COMPANY =  '仅供测试';
// export const PAGE_LOATION = '仅供测试';
// export const Imgbo = '仅供测试';
//正式
// export const PAGE_NAME = '宝山区公共租赁住房服务平台';  //all title
// export const PAGE_COMPANY = "上海市宝山区公共租赁住房运营有限公司";
// export const PAGE_LOATION = "宝山区盘古路572号1号楼4楼 联系电话: 021-56100651";
// export const Imgbo = '';

// 定义常量，控制环境
// const NODE_ENV = 'development'
const NODE_ENV = 'production'
export const PAGE_NAME = NODE_ENV == 'production' ? '上海宝山保障性住房有限公司' : '仅供测试';  //all title
export const PAGE_COMPANY = NODE_ENV == 'production' ? "上海宝山保障性住房有限公司" : '仅供测试';
export const PAGE_LOATION = NODE_ENV == 'production' ? "宝山区盘古路572号1号楼4楼 联系电话: 56671727" : '仅供测试';
export const Imgbo = NODE_ENV == 'production' ? '' : '仅供测试';

export const USERVALIDTIME = 30 * 60 * 1000;   //过期时间
export const sendNationCaptchaName = 'publicHousing_baoshan_captcha'; //拓希短信
export const companyInfo = {
    companyCode: '013',
    companyName: '上海市宝山区公共租赁住房运营有限公司'
};
export const NODE_API = "/api/oms"

// export const FILEACTIONURL = '/group1/upload' //上传总文件的action(本地上传)
export const FILEACTIONURL = '/api/oms/houses/uploadFile' 
